export const packages = [
  {
    id: 1,
    name: 'Basic',
    price: 300,
    adsAmount: 10,
    discount: 10,
    bg: 'linear-gradient(320deg, #e7e7e7 0%, #f6f7fa 100%)',
  },
  {
    id: 2,
    name: 'Silver',
    price: 300,
    adsAmount: 10,
    discount: 10,
    bg: 'linear-gradient(320deg, #d6d6d6 0%, #ededed 100%)',
  },
  {
    id: 3,
    name: 'Gold',
    price: 300,
    adsAmount: 10,
    discount: 10,
    bg: ' linear-gradient(320deg, #decfa7 0%, #ede6d2 100%)',
  },
  {
    id: 4,
    name: 'Platinum',
    price: 300,
    adsAmount: 10,
    discount: 10,
    bg: '#e2e3ea',
  },
  {
    id: 5,
    name: 'Platinum+',
    price: 300,
    adsAmount: 10,
    discount: 10,
    bg: '#d1d4e9',
  },
];
